// extracted by mini-css-extract-plugin
export default {"error":"ChangeCoverageOrcaError_error__bRCjx","successContactUs":"ChangeCoverageOrcaError_successContactUs__T555k"};